<template>
    <div>
        <div class="d-flex">
            <a
                href="#!"
                class="d-none d-md-block d-md-none d-lg-block avatar avatar-lg rounded-circle mr-3 nch--avatar-min-size"
            >
                <img
                    v-if="answer.user.upload"
                    alt="profile picture"
                    :src="image(answer.user.upload)"
                />
                <img v-else src="@img/profile.png" alt="admin profile picture" />
            </a>
            <div class="answer-container">
                <h4>{{answer.user.name}}</h4>
                <div v-if="!answer.status">
                    <Badge rounded type="warning" class="mb-3">
                        <i class="mdi mdi-information-outline"></i>
                        {{$t('topic.await')}}
                    </Badge>
                    <div class="text-muted vhtml-img" v-html="answer.comment"></div>
                </div>
                <div v-else class="vhtml-img" v-html="answer.comment"></div>
            </div>
            <div class="d-flex ml-auto">
                <h5
                    class="text-muted d-none d-md-block d-md-none d-lg-block"
                    style="text-align: right;"
                >{{timeFromNow}}</h5>
            </div>
        </div>
        <hr class="mt-2 mb-4" />
    </div>
</template>

<script>
import Badge from '../../argon/components/Badge';

export default {
    name: 'ForumAnswer',
    props: {
        answer: {
            type: Object,
            required: true,
        },
    },
    components: {
        Badge,
    },

    methods: {
        image({ host, original_file, urls }, size = 'original') {
            if (urls && urls[size]) {
                return urls[size];
            }
            return `/storage/${host}/${size}/${original_file}`;
        },
    },
    computed: {
        timeFromNow() {
            const date = this.$moment(this.answer.created_at);
            return date.fromNow();
        },
    },
};
</script>

<style>
.nch--avatar-min-size {
    min-width: 58px;
    overflow: hidden;
}

.vhtml-img p > img {
    width: 100%;
}

.answer-container {
    width: 80%;
}
</style>
